var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.17436 5.17436C4.65417 5.69454 3.81387 5.70454 3.30369 5.19436C2.79351 4.68418 2.80351 3.84388 3.3237 3.3237C3.84388 2.80351 4.68418 2.79351 5.19436 3.30369C5.70454 3.81387 5.69454 4.65417 5.17436 5.17436ZM0.772787 0.422662C0.592723 0.432666 0.432666 0.592723 0.422662 0.772787L0.00251259 6.61487C-0.0174945 6.89497 0.0825411 7.16506 0.282612 7.36514L6.56485 13.6474C7.03502 14.1175 7.78529 14.1175 8.25545 13.6474L13.6474 8.26546C14.1175 7.79529 14.1175 7.04502 13.6474 6.57485L7.35513 0.282612C7.15506 0.0825411 6.88496 -0.0174945 6.60486 0.00251259L0.762783 0.422662H0.772787Z",
    fill: "url(#paint0_linear_25084_66387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25084_66387",
    x1: 9.42634,
    y1: 14,
    x2: 4.57366,
    y2: 2.78866e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3876",
    stopOpacity: 0.519832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D030DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.a323f45e4095fe26374aab22de1ec1c7.svg";
export { ForwardRef as ReactComponent };